import { Reducer } from 'redux';

import { ScreenEditState, ScreenEditTypes } from './types';

const INITIAL_STATE: ScreenEditState = {
  data: [],
  loading: false,
  sendLoading: false,
};

const reducer: Reducer<ScreenEditState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ScreenEditTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ScreenEditTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload,
      };
    case ScreenEditTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        ...action.payload,
      };

    case ScreenEditTypes.SEND_REQUEST:
      return {
        ...state,
        sendLoading: true,
      };
    case ScreenEditTypes.SEND_SUCCESS:
      return {
        ...state,
        sendLoading: false,
        error: undefined,
        ...action.payload,
      };
    case ScreenEditTypes.SEND_FAILURE:
      return {
        ...state,
        sendLoading: false,
        ...action.payload,
      };
    case ScreenEditTypes.CLEAN_STATE:
      return {
        ...state,
        loading: false,
        sendLoading: false,
        success: undefined,
        sendError: undefined,
      };
    default:
      return state;
  }
};

export default reducer;
